import { render, staticRenderFns } from "./CreateEditUserRoles.vue?vue&type=template&id=624e47e3&"
import script from "./CreateEditUserRoles.vue?vue&type=script&lang=js&"
export * from "./CreateEditUserRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports